import { render } from "./DashboardVehiclePage.vue?vue&type=template&id=72dfdba0&scoped=true"
import script from "./DashboardVehiclePage.vue?vue&type=script&lang=js"
export * from "./DashboardVehiclePage.vue?vue&type=script&lang=js"

import "./DashboardVehiclePage.vue?vue&type=style&index=0&id=72dfdba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dfdba0"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
